import { z } from 'zod'

/**
 * RFC 7807 Problem Details envelope.
 *
 * Every error response from the API conforms to this shape with
 * `content-type: application/problem+json`. Per D-14..D-17.
 *
 * - `type` is a URN (see `urns.ts`); clients branch on it.
 * - `errors` extends the envelope for Zod validation failures (D-16).
 */
export const ProblemErrorItemSchema = z.object({
  path: z.string(),
  message: z.string(),
})

export const ProblemSchema = z.object({
  type: z.string(),
  title: z.string(),
  status: z.number().int().min(100).max(599),
  detail: z.string().optional(),
  instance: z.string().optional(),
  errors: z.array(ProblemErrorItemSchema).optional(),
})
